export * from "./trip-earning-confirm.component";
